<template>
  <div class="questionnaire-question-content">

    <div id="questionSentence" class="questionnaire-question-sentence"/>

    <div class="questionnaire-question-response">
      <div class="questionnaire-question-response-division">
        <Field id="responseDivise" autocomplete="off" class="questionnaire-question-response-division-input" name="responseDivise" @change="changeOnField()"/>
        <ErrorMessage class="error-feedback" name="responseDivise"/>
      </div>
      <img class="questionnaire-question-underline" src="@/assets/img/underline_division.png">
      <div class="questionnaire-question-response-division">
        <Field id="responseDiviseur" autocomplete="off" class="questionnaire-question-response-division-input" name="responseDiviseur" @change="changeOnField()"/>
        <ErrorMessage class="error-feedback" name="responseDiviseur"/>
      </div>
      <span id="error-regex" class="text-danger"></span>
    </div>
  </div>
</template>

<script>
import {ErrorMessage, Field} from "vee-validate";
import * as yup from "yup";
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "CalculOperationBase",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    question: String,
    subQuestion: String,
    response: String,
    regex: String,
    error: Boolean
  },
  data() {
    const schema = yup.object().shape({
      response: yup
          .number("Un numéro doit-être renseigné!")
    })

    return {
      schema
    }
  },
  methods: {
    changeOnField: function () {
      document.getElementById('error-regex').innerHTML = '';
      const value = document.getElementById('responseDivise').value + '/'
          + document.getElementById('responseDiviseur').value;

      this.answer = value;
      this.$emit('update:error', false)

    },
  },
  mounted() {
    if (document.getElementById('questionSentence')) {
      document.getElementById('questionSentence').innerHTML = this.question
    }
    UserService.getUserTestQuestions(this.$parent.domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (this.$parent.indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) {
            this.answer = arrayResponses[index]['answer']

            if (this.answer) {
              document.getElementById('responseDivise').value = this.answer.split('/')[0]
              document.getElementById('responseDiviseur').value = this.answer.split('/')[1]
            }
          }
          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
